import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import Pagination from "react-js-pagination";
import { Helmet } from "react-helmet";
import {
  fetchBadgeList,
  fetchAllBadgeList,
  searchBadge,
  getLogedinUserDeatils,
  fetchAllUserList,
} from "BadgeDesignAction";
import { fetchUsersCategory, fetchEventDetails } from "DashboardUserAction";
import NoContent, { NO_BADGEDESIGNER } from "NoContent";
import { itemCount, screenHeightLeftFromTop } from "Constants";
import BadgeDesignHeader from "./badge-design-header"; // Main page header [Short by / Search / Create]
import BadgeDesignItem from "./badge-item";
import GenerateBadge from "./generate-badge/generate-badge.js";
import GenerateOneBadge from "./generate-badge/generate-one-badge";
import LocaleStrings from "Languages";
import Loader from "Loader";

class BadgeDesign extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      sortByField: "all",
      pageNumber: 1,
      loading: true,
      desc: LocaleStrings.dashboard_badgedesign_loeader_text,
      currentTemplateId: "",
    };
  }

  componentDidMount() {
    let { session } = this.props;
    let { pageNumber } = this.state;

    // Fetch Badge Designer List For table
    this.props.fetchBadgeList(session, pageNumber, 0, (response) => {
      this.setState({ loading: false });
    });

    // Get login user details
    this.props.getLogedinUserDeatils(session, (callback) => {});

    this.props.fetchAllBadgeList(session);
    this.props.fetchAllUserList(session);
    this.props.fetchUsersCategory(session);
    this.props.fetchEventDetails(session);
  }

  componentWillUnmount() {
    this.reinitializeStatesAndProps();
  }

  // Reintialize states and props
  reinitializeStatesAndProps() {
    // States
    this.setState({
      search: "",
      sortByField: "all",
      pageNumber: 1,
      loading: true,
      desc: LocaleStrings.dashboard_badgedesign_loeader_text,
      currentTemplateId: "",
    });
    // Props
  }

  // Set search text
  setSearch(value) {
    let { session } = this.props;
    let { search } = this.setState;

    if (search !== value) {
      this.setState({
        search: value,
      });
    }

    if (value !== "" && _.size(value) > 3) {
      // Search is there [Reset page number and DO API call]
      this.setState({
        pageNumber: 1,
      });

      this.props.searchBadge(session, value, 1, (response) => {});
    } else {
      // When user remove all charecters form search [Reset all state]
      this.setState({
        pageNumber: 1,
      });
      this.props.fetchBadgeList(session, 1, 0, (response) => {});
    }
  }

  // Set short by [Ex- Name]
  setSortByField(value) {
    if (this.state.sortByField !== value) {
      this.setState({
        sortByField: value,
      });
    }
  }

  additionCallback = (pageNo = "") => {
    this.props.fetchAllBadgeList(this.props.session);
    this.paginationCallback(pageNo !== "" ? pageNo : this.state.pageNumber);
  };

  /*
    Pagination Function for badge list
  */
  paginationCallback = (pageNumber) => {
    let { session } = this.props;
    let { search } = this.state;

    if (search === "") {
      this.props.fetchBadgeList(session, pageNumber, 0, (response) => {});
    } else if (search !== "") {
      // Search
      this.props.searchBadge(session, search, pageNumber, (response) => {});
    } else {
    }

    this.setState({ ...this.state, pageNumber });
  };

  /* Update Current template id on genarate badge modal open */
  setStateCurrentTemplateId = (templateId) => {
    this.setState({ currentTemplateId: templateId });
  };

  /* Badge list */
  renderBadgeList() {
    let { badgetList } = this.props;
    let { pageNumber } = this.state;
    let pageDataLength = badgetList.data.length;

    return _.map(badgetList.data, (badge) => {
      return (
        <BadgeDesignItem
          key={badge.badgeid}
          badgeTemplate={badge}
          additionCallback={this.additionCallback}
          pagination={this.paginationCallback}
          pageDataLength={pageDataLength}
          currentPage={pageNumber}
          setStateCurrentTemplateId={this.setStateCurrentTemplateId}
        />
      );
    });
  }

  render() {
    let { badgetList, deviceSize } = this.props;
    let { desc, loading, pageNumber, currentTemplateId, search, sortByField } =
      this.state;

    return (
      <>
        <div>
          {/* <Helmet>
            <script src="../../style/external/html2pdf.js"></script>
          </Helmet> */}

          {/* `Main page header [Short by / Search / Create] ` */}
          <BadgeDesignHeader
            history={this.props.history}
            search={search}
            setSearch={(e) => this.setSearch(e)}
            sortByField={sortByField}
            setSortByField={(e) => this.setSortByField(e)}
            finishOperationsCallback={this.additionCallback}
          />
          {/* Table */}

          <div
            className="panel-body scrollable-content"
            style={{ height: deviceSize.height - screenHeightLeftFromTop }}
          >
            {loading ? (
              <div className="loader-container">
                <Loader />
                <div className="loader-info">{desc}</div>
              </div>
            ) : badgetList.data && badgetList.data.length > 0 ? (
              <div className="main-table-container">
                <table className="table">
                  <thead>
                    <tr>
                      <th style={{ width: "40%" }}>
                        {LocaleStrings.dashboard_badgedesign_table_thead1}
                      </th>
                      <th style={{ width: "25%" }}>
                        {LocaleStrings.dashboard_badgedesign_table_thead2}
                      </th>
                      <th style={{ width: "35%" }}>
                        {LocaleStrings.dashboard_badgedesign_table_thead3}
                      </th>
                    </tr>
                  </thead>
                  <tbody className="tbody-background">
                    {this.renderBadgeList()}
                  </tbody>
                </table>
                {badgetList && badgetList.count > itemCount ? (
                  <Pagination
                    activePage={pageNumber}
                    itemsCountPerPage={itemCount}
                    totalItemsCount={badgetList.count}
                    pageRangeDisplayed={10}
                    onChange={this.paginationCallback}
                    style={{ float: "right" }}
                  />
                ) : null}
              </div>
            ) : (
              <NoContent contentType={NO_BADGEDESIGNER} />
            )}
          </div>
          {/* Multiple badge generate at a time */}
          <GenerateBadge
            history={this.props.history}
            setStateCurrentTemplateId={this.setStateCurrentTemplateId}
            currentTemplateId={currentTemplateId}
          />

          {/* Generate only one badge at a time */}
          {/* <GenerateOneBadge
            history={this.props.history}
            setStateCurrentTemplateId={this.setStateCurrentTemplateId}
            currentTemplateId={currentTemplateId}
          /> */}
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    deviceSize: state.deviceSize,
    badgetList: state.dashboardBadgeList,
  };
}

export default connect(mapStateToProps, {
  // all actions
  fetchBadgeList, // Fetch badge list
  fetchAllBadgeList,
  searchBadge, // Search badge
  getLogedinUserDeatils, // Login user details
  fetchAllUserList,
  fetchUsersCategory,
  fetchEventDetails,
})(BadgeDesign);
